import { FC } from 'react';
import Button from '../button/button';
import Textarea from '../textarea/textarea';

interface CollapsableControlI {
    collapsableId?: string;
    placeholder?: string;
    isLoading: boolean;
    isEditing: boolean;
    comment: string;
    onChange(newComment: string): void;
    onEdit(): void | Promise<unknown>;
    onCreate(): void | Promise<unknown>;
    handleResetEditMode(): void;
    disabled?: boolean;
    sendButton?: {
        className?: string;
        disabled?: boolean;
    };
}

const CollapsableControl: FC<CollapsableControlI> = ({
    collapsableId = 'test',
    placeholder = 'Comentario',
    isLoading,
    isEditing,
    comment,
    onChange,
    onEdit,
    onCreate,
    handleResetEditMode,
    disabled,
    sendButton,
}) => {
    return (
        <div className="flex space-x-1.5 p-1.5 items-end">
            <Textarea
                className="h-[38px] min-h-[38px] max-h-20 !text-base !px-2 !py-1.5"
                id={`${collapsableId}-textarea`}
                name={`${collapsableId}-textarea`}
                placeholder={placeholder}
                value={comment}
                disabled={disabled}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
            />
            <Button
                color="primary"
                className={`[&>span>i]:!mx-2 ${sendButton?.className}`}
                iconName="ri-send-plane-2-line"
                onClick={async () => {
                    if (isEditing) {
                        onEdit();
                    } else {
                        onCreate();
                    }
                }}
                disabled={isLoading || disabled || sendButton?.disabled}
                loading={isLoading}
            />
            {isEditing && (
                <Button
                    color="secondary"
                    className="[&>span>i]:!mx-2"
                    iconName="ri-close-line"
                    variant="outlined"
                    onClick={() => {
                        handleResetEditMode();
                    }}
                />
            )}
        </div>
    );
};

export default CollapsableControl;
